<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <pr-input-radio
                formControlName="userTitle"
                direction="column"
                [isDefault]="false"
                columns="3"
                label="Votre civilité"
                [options]="options"
              >
              </pr-input-radio>
              <div class="row">
                @if (!owner.get('userHasEmail')?.value) {
                  <div
                    class="col-md-{{ col }} "
                    [ngClass]="{ 'w-100': owners.length > 1 }"
                  >
                    <pr-input-column label="Email" [derrors]="derrors">
                      <input formControlName="userEmail" type="text" />
                      <pr-icon name="email"></pr-icon>
                    </pr-input-column>
                  </div>
                }
                <div
                  class="col-md-{{ col }}  "
                  [ngClass]="{
                    'w-100':
                      owners.length > 1 || owner.get('userTitle').value == 'M',
                  }"
                >
                  <pr-input-column
                    label="Votre nom"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                    <input formControlName="userLastName" type="text" />
                  </pr-input-column>
                </div>
                <div
                  class="col-md-{{ col }}  "
                  [ngClass]="{ 'w-100': owners.length > 1 }"
                >
                  <pr-input-column
                    label="Votre nom de naissance"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                    <input formControlName="userBirthName" type="text" />
                  </pr-input-column>
                </div>
              </div>
              <div class="row" style="margin-bottom: 0">
                <div
                  class="col-md-{{ col }} "
                  [ngClass]="{ 'w-100': owners.length > 1 }"
                >
                  <pr-input-column label="Prénom d'usage" [derrors]="derrors">
                    <input
                      placeholder="Exemple : Dupont"
                      formControlName="userFirstName"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div
                  class="col-md-{{ col }} "
                  [ngClass]="{ 'w-100': owners.length > 1 }"
                >
                  <first-second-names
                    formArrayName="userOtherFirstNames"
                    [derrors]="derrors"
                  >
                  </first-second-names>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <pr-input-column
                    label="Numéro de sécurité sociale"
                    [derrors]="derrors"
                  >
                    <input
                      placeholder="Exemple : 187045612345678"
                      formControlName="userSocialSecurityNumber"
                      type="text"
                      prSocialSecurityNumber
                    />
                  </pr-input-column>
                </div>
                <div class="col-md-6">
                  <pr-input-column label="Régime social" [derrors]="derrors">
                    <mat-select formControlName="userSocialRegime">
                      @for (option of userSocialRegimeOptions; track option) {
                        <mat-option [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
              @if (productType == 'GIRARDIN') {
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Nom du père" [derrors]="derrors">
                      <input
                        placeholder="Exemple : Dupont"
                        formControlName="userFatherLastName"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Prénom du père" [derrors]="derrors">
                      <input
                        placeholder="Exemple : Jean"
                        formControlName="userFatherFirstName"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Nom de la mère" [derrors]="derrors">
                      <input
                        placeholder="Exemple : Dupont"
                        formControlName="userMotherLastName"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column
                      label="Prénom de la mère"
                      [derrors]="derrors"
                    >
                      <input
                        placeholder="Exemple : Sylvie"
                        formControlName="userMotherFirstName"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
              }
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
